import React from 'react';
import { useNavigate } from 'react-router-dom';
// Mui components
import { Box, Button, Typography } from '@mui/material';
// Components
import SmallModalContainer from '../../common/SmallModalContainer';
// Icons
import iconCheck from '../../../assets/icons/icon_circle-check.svg';

function ModalSuccessPost({ openModals, onHandleClose, clearForm }) {
    const navigate = useNavigate();

    const handleNavigate = () => {
        clearForm();
        navigate('/prestador/dashboard');
    };

    return (
        <SmallModalContainer open={openModals}
            onClose={onHandleClose}>
            <Box display="flex" flexDirection="column" gap={"1rem"}>
                <Box
                    component="img"
                    sx={{ width: "54px", height: "54px" }}
                    alt="img not found"
                    src={iconCheck}
                />
                <Typography variant="h1">Tu solicitud fue enviada</Typography>
                <Typography variant="h4" component="p">Será analizada por nuestro equipo.</Typography>
                <Typography variant="h5" component="p">Podés realizar el seguimiento de su estado desde la página de inicio.</Typography>
                <Box display="flex" gap={"1rem"} marginTop="1.5rem">
                    <Button
                        onClick={() => handleNavigate()}
                        variant="contained"
                        sx={{ height: "48px", borderRadius: "16px", width: "100%" }}>
                        <Typography variant="cta" component="span"
                        >Volver al inicio
                        </Typography>
                    </Button>
                </Box>
            </Box>
        </SmallModalContainer>
    );
}

export default ModalSuccessPost;